import React from 'react'
import { Card, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { ProjectType } from '../../../api/projects-api'
import { setLocation } from '../../../app/cookies'

type PropsType = {
  project: ProjectType
}

export const Project = React.memo((props: PropsType) => {
  console.log('PROJECT is called!', props.project.id)
  const navigate = useNavigate();

  return (
    <Card className='projectCard' onClick={() => {
      setLocation(props.project.projectName, props.project.id, 1)
      navigate(`/project/${props.project.projectName}`)}}>
      <h3>
        {props.project.projectName} 
      </h3>
      <Typography>
        {props.project.projectDescription}
        <Typography>
        </Typography>
      </Typography>
    </Card>
  )
})
